import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

const initialState = {
  mainOrder: null,
  orderDetails: [],
  additionalDetails: [],
};

const partyDetailsSlice = createSlice({
  name: "partyDetail",
  initialState: initialState,
  reducers: {
    setMainOrder: (state, action) => {
      state.mainOrder = action.payload;
    },
    setOrderDetails: (state, action) => {
      state.orderDetails = action.payload.map((value) => ({
        ...value,
        description: value.product?.name || "",
      }));
    },
    setAdditionalDetails: (state, action) => {
      state.additionalDetails = action.payload.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    },

    clearVehicleDetails: (state) => {
      state.mainOrder = null;
      state.orderDetails = [];
      state.additionalDetails = [];
    },
  },
});

export const { setMainOrder, setOrderDetails, setAdditionalDetails, clearVehicleDetails } = partyDetailsSlice.actions;

export default partyDetailsSlice.reducer;
